import { 
POST_INVITE_CODE_POC_READ, POST_INVITE_CODE_POC_COUNT, POST_INVITE_CODE_POC_DOWNLOAD
} from "@/api/apiConst/poc"; 
import request from "@/api/http/request";
 

interface InviteCodePocReadType { 
  code: string; 
  data: number
}
// 认证邀请码POC用户校验读取状态
export function inviteCodePocRead() {
  return request.post<InviteCodePocReadType>(POST_INVITE_CODE_POC_READ)
}

//认证邀请码POC用户验证码列表
export function inviteCodePocCount() {
  return request.post<{ [props: string]: any }>(POST_INVITE_CODE_POC_COUNT)
}

//认证邀请码POC用户下载表格
export function inviteCodePocDownload() {
  return request.post(POST_INVITE_CODE_POC_DOWNLOAD, {}, { responseType: "arraybuffer" }) // 表明返回服务器返回的数据类型
}
